module.exports = __webpack_public_path__ + "img/feedback4-1.1080e3e1.jpg";